import { useTimezonesQuery } from '@src/hooks/avaTimezonesApi';
import { useCallback } from 'react';
import { useDisplaySettings } from '../../../../providers/DisplaySettingsProvider';
import { customEODToRequestEOD } from './customEODToRequestEOD';

export type ResolveRequestEndOfDay = (previousEndOfDay?: string) => string | undefined;

/** Resolves EndOfDay for position requests, preserving the prior value while Ava timezones load. */
export function useRequestEndOfDay(): ResolveRequestEndOfDay {
  const { customEOD } = useDisplaySettings();
  const { data: timezones, isUninitialized, isLoading } = useTimezonesQuery();

  return useCallback(
    (previousEndOfDay?: string): string | undefined => {
      if (isUninitialized || isLoading) {
        return previousEndOfDay;
      }

      const supportedTimezoneNames = timezones?.map(timezone => timezone.Name) ?? [];
      return customEODToRequestEOD(customEOD, supportedTimezoneNames, new Date());
    },
    [customEOD, timezones, isUninitialized, isLoading]
  );
}
